import React, { useState, useEffect } from "react";
import Header from "../Components/Dashboard/Header";
import SalesBarChart from "../Components/Dashboard/SalesBarChart";
import SalesPieChart from "../Components/Dashboard/SalesPieChart";
import TopSellingProduct from "../Components/Dashboard/TopSellingProduct";
import { fetchDashboardData } from "../actions/DashboardAction";
import Loading from "../Components/Layout/Loading";
import { getDashboard, getDoctorSale } from "../services/dashboardService";

const Dashboard = ({ userRole }) => {
  const [stats, setStats] = useState([]);
  const [salesData, setSalesData] = useState([]);
  const [productSales, setProductSales] = useState([]);
  const [topSellingProductsData, setTopSellingProductsData] = useState([]);
  const [distributor, setDistributor] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch sales data
  const getAllDashboardData = async () => {
    try {
      setIsLoading(true);
      const response = await fetchDashboardData(distributor);
      console.log("res", response.salesProducts);
      setStats(response.stats);
      setProductSales(response.salesProducts);
      // setSalesData(response.sales);
      setTopSellingProductsData(response.topSellingProducts);
      setError(null);
    } catch (err) {
      console.error("Sales data fetch error:", err);
      setError("Failed to fetch sales data");
      setSalesData([]);
    } finally {
      setIsLoading(false);
    }
  };

  // const getAllDashboardData1 = async() => {
  //   try {
  //     const response = await getDashboard (
  //       {
  //         category: "sales tracking",
  //         page_size: 50,
  //         start_date: "2024-01-01",
  //         end_date: "2024-12-31",
  //         page_number: 1
  //       }
  //     )
  //   } catch (error) {

  //   }
  // }
  // useEffect(() => {
  //   getDashboard(
  //     {
  //       category: "sales tracking",
  //       page_size: 50,
  //       start_date: "2024-01-01",
  //       end_date: "2024-12-31",
  //       page_number: 1
  //     }
  //   )
  // }, []);

  // Fetch data on component mount
  useEffect(() => {
    getAllDashboardData();
  }, [distributor]);

  // Render loading state
  if (isLoading) {
    return (
      <div className="top-0">
        <Loading />
      </div>
    );
  }

  // Render error state
  if (error) {
    return (
      <div className="text-primary text-center p-4">
        {error}
        <button
          onClick={getAllDashboardData}
          className="ml-2 px-3 py-1 bg-primary text-white rounded"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="w-full px-0 sm:px-4  ">
      <Header
        userRole={userRole}
        setDistributor={setDistributor}
        distributor={distributor}
        stats={stats}
      />
      <div className="w-full mb-4">
        <SalesBarChart setSalesData={setSalesData} />
      </div>

      <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row gap-4 ">
        <div className="w-full sm:w-1/2  md:w-full mb-4  md:mb-0">
          <SalesPieChart salesData={salesData} />
        </div>

        <div className="w-full sm:w-1/2  md:w-full  ">
          <TopSellingProduct topSellingProductsData={topSellingProductsData} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
